import type { EdgeId, NodeSn } from '@ipfabric/utils';
import type {
  PathLookupPathInspectorHighlightedEdges,
  Pathlookup,
} from '../GraphState';

const isEdgeHighlightedInPathInspector = (
  highlightedEdges: PathLookupPathInspectorHighlightedEdges,
  edgeId: EdgeId,
  activeNodeSn: NodeSn,
): boolean => {
  return (
    // Fixed noUncheckedIndexedAccess NIM-19408
    highlightedEdges[activeNodeSn] !== undefined &&
    (highlightedEdges[activeNodeSn]?.incomingEdges.includes(edgeId) ||
      highlightedEdges[activeNodeSn]!.outgoingEdges.includes(edgeId))
  );
};

export const canSelectHighlightedPathLookupEdge = (
  edgeId: EdgeId,
  pathLookup: Pathlookup,
): boolean => {
  const { activeNodeSn, highlightedEdges } = pathLookup.pathInspector;
  return (
    activeNodeSn !== null &&
    isEdgeHighlightedInPathInspector(highlightedEdges, edgeId, activeNodeSn)
  );
};
